export const TEST_ID = 'stateComplianceModalFooter';

export const CLOSE_BUTTON_TEST_ID = 'stateComplianceModalCloseButton';

export const PDF_BUTTON_TEST_ID = 'stateComplianceModalPdfButton';
